import React from 'react';
import Modal from './Modal';
import './ConfirmModal.scss'

interface ConfirmModalProps {
  onConfirm: () => void;
  onCancel: () => void;
  isModalOpen: boolean;
  title?: string;
  description?: string;
  confirmText?: string;
  cancelText?: string;
  element: any;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  onConfirm,
  onCancel,
  isModalOpen,
  title,
  description,
  confirmText,
  cancelText,
  element
}: ConfirmModalProps) => {
  // set default texts if not provided
  title = title || 'Are you sure?';
  description = description || `You can't undo this action.`;
  confirmText = confirmText || 'Continue';
  cancelText = cancelText || 'Cancel';

  return (
    <Modal
      onClose={onCancel}
      isModalOpen={isModalOpen}
      el={element}
      modalWidth="35%"
    >
      {
        <div className="confirm__container">
          <h3 className="confirm__title">{title}</h3>
          <p className="confirm__description">{description}</p>
          <div className="confirm__action-container">
            <button className="btn btn-primary confirm__action" onClick={onConfirm}>
              {confirmText}
            </button>
            <button className="btn btn-outline-secondary confirm__action" onClick={onCancel}>
              {cancelText}
            </button>
          </div>
        </div>
      }
    </Modal>
  );
};

export default ConfirmModal;
